"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRenderValue = exports.getPathValue = void 0;
var base_1 = require("./base");
function toArray(arr) {
    if (arr === undefined || arr === null) {
        return [];
    }
    return (Array.isArray(arr) ? arr : [arr]);
}
/**
 * 通过path获取值
 */
var getPathValue = function (record, path) {
    // Skip if path is empty
    if (!path && typeof path !== 'number') {
        return '';
    }
    var pathList = toArray(path);
    var current = record;
    for (var i = 0; i < pathList.length; i += 1) {
        if (!current) {
            return '';
        }
        var prop = pathList[i];
        current = current[prop];
    }
    return current;
};
exports.getPathValue = getPathValue;
/**
 * 获取render值
 */
var getRenderValue = function (renderResult) {
    var values = [];
    var dealChildren = function (child) {
        if ((0, base_1.sameType)(child, 'String') || (0, base_1.sameType)(child, 'Number')) {
            values.push(child);
        }
        if ((0, base_1.sameType)(child, 'Object')) {
            var children = child.props.children;
            if ((0, base_1.sameType)(children, 'String') || (0, base_1.sameType)(children, 'Number')) {
                values.push(children);
            }
            if ((0, base_1.sameType)(children, 'Object')) {
                dealChildren(children);
            }
            if ((0, base_1.sameType)(children, 'Array')) {
                children.forEach(function (_child) {
                    dealChildren(_child);
                });
            }
        }
        if ((0, base_1.sameType)(child, 'Array')) {
            child.forEach(function (_child) {
                dealChildren(_child);
            });
        }
    };
    // 解决数据为{ children: 0 }时会变为''的问题
    if ((renderResult === null || renderResult === void 0 ? void 0 : renderResult.children) || (renderResult === null || renderResult === void 0 ? void 0 : renderResult.children) === 0) {
        dealChildren(renderResult.children);
    }
    else {
        dealChildren(renderResult);
    }
    return values.join('');
};
exports.getRenderValue = getRenderValue;
